import type { CartaoCliente, ClientePainel, EnderecoCliente } from "../../../services/edicaoCliente"

export type { CartaoCliente, EnderecoCliente }

export type EdicaoClienteModel = {
    id: number
    nome: string
    cpf: string
    email: string
    telefone: string
    dataNascimento: string
    taxaEntrega: string
    observacao: string
    vip: boolean
    freteGratis: boolean
    pontuarNaFidelidade: boolean
    receberSpam: boolean
    ativo: boolean
    usuarioSimplificado: boolean
    permissoes: string[]
    enderecos: EnderecoCliente[]
    cartoes: CartaoCliente[]
    carregado: boolean
}

export type CampoEditavel =
    | "nome"
    | "cpf"
    | "email"
    | "telefone"
    | "dataNascimento"
    | "taxaEntrega"
    | "observacao"
    | "vip"
    | "freteGratis"
    | "pontuarNaFidelidade"
    | "receberSpam"

export const EdicaoClienteInicial: EdicaoClienteModel = {
    id: 0,
    nome: "",
    cpf: "",
    email: "",
    telefone: "",
    dataNascimento: "",
    taxaEntrega: "",
    observacao: "",
    vip: false,
    freteGratis: false,
    pontuarNaFidelidade: false,
    receberSpam: false,
    ativo: true,
    usuarioSimplificado: false,
    permissoes: [],
    enderecos: [],
    cartoes: [],
    carregado: false,
}

export function msParaInputDate(ms: number | null): string {
    if (ms === null || ms === undefined || isNaN(ms)) return ""
    const data = new Date(ms)
    if (isNaN(data.getTime())) return ""
    const mes = String(data.getMonth() + 1).padStart(2, "0")
    const dia = String(data.getDate()).padStart(2, "0")
    return `${data.getFullYear()}-${mes}-${dia}`
}

export function isDataValida(str: string): boolean {
    if (!str || str.length !== 10) return false
    const data = new Date(str + "T00:00:00")
    if (isNaN(data.getTime())) return false
    const [ano, mes, dia] = str.split("-").map(Number)
    return data.getFullYear() === ano && data.getMonth() + 1 === mes && data.getDate() === dia
}

export function clientePainelParaModel(cliente: ClientePainel): EdicaoClienteModel {
    return {
        id: cliente.id,
        nome: cliente.nome ?? "",
        cpf: cliente.cpf ?? "",
        email: cliente.email ?? "",
        telefone: cliente.telefone ?? "",
        dataNascimento: msParaInputDate(cliente.dataNascimento),
        taxaEntrega:
            cliente.taxaEntrega !== null && cliente.taxaEntrega !== undefined
                ? String(cliente.taxaEntrega)
                : "",
        observacao: cliente.observacao ?? "",
        vip: cliente.vip,
        freteGratis: cliente.freteGratis,
        pontuarNaFidelidade: cliente.pontuarNaFidelidade,
        receberSpam: cliente.receberSpam,
        ativo: cliente.ativo,
        usuarioSimplificado: cliente.usuarioSimplificado,
        permissoes: cliente.permissoes ?? [],
        enderecos: cliente.enderecos ?? [],
        cartoes: cliente.cartoes ?? [],
        carregado: true,
    }
}
